import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {
  displayContent: string = 'user-list';

  userForm!: FormGroup;
  constructor(public _formBuilder: FormBuilder) { }

  ngOnInit(): void {
      this.BuildUserForm();
  }


  BuildUserForm(){
    this.userForm = this._formBuilder.group({
      userEmail: ['',[Validators.required, Validators.email]],
      userFirstname: ['', Validators.required],
      userLastname: ['', Validators.required],
      userMobile: ['', Validators.required],
      userUsername: ['', Validators.required],
      newRole: ['', Validators.required]
    })
  }

  onSubmit(){
    if(this.userForm){
      console.log("Created User Data", this.userForm.value);
    }
    else{
      console.log("User not created");
    }
  }

  showData(data: string){
    this.displayContent = data;
  }

}
